import { ReactNode } from 'react';
import cn from 'classnames';
import { ReactComponent as InfoIcon } from '../../static/images/info-circle.svg';
import { ReactComponent as AlertIcon } from '../../static/images/icons/alert.svg';

import './InfoBox.styles.css';

interface InfoBoxProps {
    variant?: 'info' | 'warning';
    title?: ReactNode;
    description?: ReactNode;
}

const InfoBox = ({ variant = 'info', title, description }: InfoBoxProps) => {
    return (
        <div className={cn('infoBox', `infoBox-${variant}`)}>
            {variant === 'info' && (
                <div className="infoBox__icon">
                    <InfoIcon />
                </div>
            )}
            {variant === 'warning' && (
                <div className="infoBox__icon">
                    <AlertIcon />
                </div>
            )}
            <div className="infoBox__content">
                {title && <p className="infoBox__title">{title}</p>}
                {description && <p className="infoBox__description">{description}</p>}
            </div>
        </div>
    );
};

export default InfoBox;
